import React from "react";
import UsersIcon from "src/img/new/users.svg";
import CheckBlueIcon from "src/img/Blue-check.svg";
import SearchIcon from "src/img/new/search-gray.svg";
import { ACCOUNT_OWNER } from "src/constants/roles";
import { generateNameInitials } from "src/utils/helpers";
import StyledSwitch from "src/components/StyledSwitch";
import { BulkAssignmentPanel, BulkSelectedStrip,
    SelectedUsersLabel, SelectedUsersCard,
    SelectedUsersIcon, BulkUserSection,
    BulkUserSectionHeader, BulkUserSectionTitle,
    BulkAssignedCount, BulkUserControls,
    BulkSearchWrapper, BulkSearchInput,
    AllUsersToggle, BulkUsersTableContainer,
    BulkUsersTable, BulkUsersTH,
    BulkUsersTD, BulkUserNameCell,
    BulkUserAvatar, BulkUserName,
    BulkAssignButton, EmptyBulkUsers,
    BulkSectionDivider, BulkSectionHeader,
    BulkSectionTitle, BulkSectionDescription
} from "./BulkPermissionStyle";

const ToggleAllUsersSwitch = (props) => (
    <StyledSwitch
        switchMargin={8}
        checkedTrackColor="#1A61FF"
        thumbBorderColor="#bdbdbd"
        thumbBackgroundColor="#FFFF"
        trackBackgroundColor="#00000029"
        trackHeight={20}
        trackRadius={23 / 2}
        {...props}
    />
);


function BulkPermissionAssignment({
    isDataFetchFinished, 
    selectedBulkUserUuids, 
    userTypeLabel, 
    bulkSearchKey, 
    setBulkSearchKey, 
    disableInput,
    allBulkUsersSelected,
    selectableBulkUsers,
    filteredBulkUsers,
    toggleBulkUser,
    selectAllBulkUsers,
    userTypeLabelSingular,
}) {
    if (!isDataFetchFinished) {
        return null;
    }

    return (
        <>
            <BulkSectionDivider />

            <BulkSectionHeader>
                <BulkSectionTitle>
                    Select {userTypeLabel} Manually
                </BulkSectionTitle>

                <BulkSectionDescription>
                    Select individual {userTypeLabel} to manually assign these roles and permissions.
                    Only selected {userTypeLabel} will receive access.
                </BulkSectionDescription>
            </BulkSectionHeader>

            <BulkAssignmentPanel>
                <BulkSelectedStrip>
                    <SelectedUsersLabel>
                    Selected Users:
                    </SelectedUsersLabel>

                    <SelectedUsersCard>
                        <SelectedUsersIcon>
                            <img
                                src={UsersIcon}
                                alt=""
                                width="18"
                                height="18"
                            />
                        </SelectedUsersIcon>

                        <strong>
                            {selectedBulkUserUuids.length} {userTypeLabel}
                        </strong>
                    </SelectedUsersCard>
                </BulkSelectedStrip>

                <BulkUserSection>
                    <BulkUserSectionHeader>
                        <BulkUserSectionTitle>
                        Select {userTypeLabel}
                        </BulkUserSectionTitle>

                        <BulkAssignedCount>
                            {selectedBulkUserUuids.length} {userTypeLabel} Assigned Permissions
                        </BulkAssignedCount>
                    </BulkUserSectionHeader>

                    <BulkUserControls>
                        <BulkSearchWrapper>
                            <BulkSearchInput
                                value={bulkSearchKey}
                                onChange={(event) =>
                                    setBulkSearchKey(event.target.value)
                                }
                                placeholder={`Search ${userTypeLabel.toLowerCase()}`}
                                disabled={disableInput}
                            />
                            <img src={SearchIcon} alt="" />
                        </BulkSearchWrapper>

                        <AllUsersToggle>
                            <span>All {userTypeLabel}</span>

                            <ToggleAllUsersSwitch
                                checked={allBulkUsersSelected}
                                onChange={(event) =>
                                    selectAllBulkUsers(event.target.checked)
                                }
                                disabled={
                                    disableInput ||
                                selectableBulkUsers.length === 0
                                }
                            />
                        </AllUsersToggle>
                    </BulkUserControls>

                    <BulkUsersTableContainer>
                        <BulkUsersTable>
                            <thead>
                                <tr>
                                    <BulkUsersTH style={{ width: "38%" }}>
                                    Name
                                    </BulkUsersTH>

                                    <BulkUsersTH>
                                    Department / Group
                                    </BulkUsersTH>

                                    <BulkUsersTH>
                                    Job Title
                                    </BulkUsersTH>

                                    <BulkUsersTH
                                        style={{
                                            textAlign: "center",
                                            width: "8.5rem"
                                        }}
                                    >
                                    Assign User
                                    </BulkUsersTH>
                                </tr>
                            </thead>

                            <tbody>
                                {filteredBulkUsers.map(user => {
                                    const isAccountOwner =
                                    user.roleAndPermissions?.roleId === ACCOUNT_OWNER;

                                    const isSelected =
                                    selectedBulkUserUuids.includes(user.uuid);

                                    const fullName =
                                    `${user.firstName || ""} ${user.lastName || ""}`.trim();

                                    return (
                                        <tr key={user.uuid}>
                                            <BulkUsersTD>
                                                <BulkUserNameCell>
                                                    <BulkUserAvatar>
                                                        {generateNameInitials(
                                                            user.firstName,
                                                            user.lastName
                                                        )}
                                                    </BulkUserAvatar>

                                                    <BulkUserName>
                                                        {fullName || user.email}
                                                    </BulkUserName>
                                                </BulkUserNameCell>
                                            </BulkUsersTD>

                                            <BulkUsersTD>
                                                {user.isClient
                                                    ? user.employmentPosition || "-"
                                                    : user.department || "-"}
                                            </BulkUsersTD>

                                            <BulkUsersTD>
                                                {user.isClient
                                                    ? "-"
                                                    : user.employmentPosition || "-"}
                                            </BulkUsersTD>

                                            <BulkUsersTD>
                                                <BulkAssignButton
                                                    type="button"
                                                    $checked={isSelected}
                                                    onClick={() =>
                                                        toggleBulkUser(user.uuid)
                                                    }
                                                    disabled={
                                                        disableInput ||
                                                    isAccountOwner
                                                    }
                                                    title={
                                                        isAccountOwner
                                                            ? "Account Owner permissions cannot be changed."
                                                            : `Assign ${userTypeLabelSingular}`
                                                    }
                                                >
                                                    {isSelected && (
                                                        <img
                                                            src={CheckBlueIcon}
                                                            alt=""
                                                        />
                                                    )}
                                                </BulkAssignButton>
                                            </BulkUsersTD>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </BulkUsersTable>

                        {filteredBulkUsers.length === 0 && (
                            <EmptyBulkUsers>
                            No {userTypeLabel.toLowerCase()} available.
                            </EmptyBulkUsers>
                        )}
                    </BulkUsersTableContainer>
                </BulkUserSection>
            </BulkAssignmentPanel>
        </>
    );
}

export default BulkPermissionAssignment;
